module.exports = __webpack_public_path__ + "static/media/27.04e7b31e.jpg";